// ArChat Language Extension
// Created: 13-03-2026 00:30:00
// Author: SIVOL® - Aldo Frias - Argentina

import { plansTranslationsEn } from './plansTranslations.en.js';

export const plansTranslationsHe = {
  ...plansTranslationsEn,
  'plans.modal.title': 'שדרוג תוכנית',
  'plans.modal.comparison_title': 'השוואת תוכניות',
  'plans.modal.billing_period': '',
  'plans.modal.price_note': '',
  'plans.free.title': 'FREE',
  'plans.free.subtitle': 'תוכנית חינמית',
  'plans.free.features.contacts': 'עד 2 אנשי קשר למשתמש',
  'plans.free.features.conversations': 'עד 2 שיחות פעילות לחשבון',
  'plans.free.features.no_export': '30,000 תווים לחודש לחשבון; 34 הודעות ליום ו-1,000 לחודש; ללא ייצוא',
  'plans.free.features.no_advanced': 'ללא קבצים או אחסון; היסטוריה 30 יום; מכשיר אחד למשתמש',
  'plans.foundation.title': 'FOUNDATION',
  'plans.foundation.subtitle': 'תוכנית Founder',
  'plans.foundation.features.contacts': 'אותו חוזה פרימיום כמו PRO (עד 100 אנשי קשר למשתמש)',
  'plans.foundation.features.conversations': 'צ\'אטים ללא הגבלה (דייר); אותן מגבלות כמו PRO',
  'plans.foundation.features.badge': 'תוכנית Founder (150 מקומות ממוספרים)',
  'plans.foundation.features.support': 'USD 15 לחודש כל עוד יש מקומות Founder',
  'plans.pro.title': 'PRO',
  'plans.pro.subtitle': 'תוכנית Pro',
  'plans.pro.features.contacts': 'עד 100 אנשי קשר למשתמש',
  'plans.pro.features.conversations': 'צ\'אטים ללא הגבלה (דייר); 1,667 הודעות ליום, 50k לחודש',
  'plans.pro.features.export': 'עד 50 MB (דייר); ייצוא, תרגום אוטומטי וקבצים לפי התוכנית',
  'plans.pro.features.notifications': 'עד 3 מכשירים למשתמש; הזמנות ללא הגבלה (דייר)',
  'plans.actions.free': 'התוכנית הנוכחית',
  'plans.actions.foundation': 'הפוך ל-Founder',
  'plans.actions.pro': 'שדרג ל-PRO',
  'plans.badges.recommended': 'מומלץ',
  'plans.badges.limited': 'מוגבל',
  'plans.compare.title': 'בחר את התוכנית שלך',
  'plans.compare.cta.foundation': 'הפוך ל-Founder',
  'plans.compare.cta.pro': 'שדרג ל-PRO',
  'plans.compare.active': 'התוכנית הנוכחית',
  'plans.limit.reached': 'הגעת למגבלה — שדרוג תוכנית',
  'plans.compare.pro.adjustment_notice': 'המחיר עשוי להתעדכן בהתאם לתנאי השירות.',
  'plans.compare.free.title': 'FREE',
  'plans.compare.foundation.title': 'FOUNDATION ⭐',
  'plans.compare.pro.title': 'PRO',
  'plans.compare.foundation.badge': '150 limited slots',
  'plans.compare.limited': '',
  'plans.foundation.best_value': '',
  'plans.foundation.savings': '',
  'plans.limit.title.messages': 'Message limit reached',
  'plans.limit.message.messages': 'You reached your message limit. Upgrade to FOUNDATION or PRO.',
  'plans.limit.title.storage': 'Storage limit reached',
  'plans.limit.message.storage': 'You reached your storage limit. Upgrade to upload more files.',
  'plans.limit.title.invitations': 'Invitation limit reached',
  'plans.limit.message.invitations': 'You reached your invitation limit. Upgrade to invite more.',
  'plans.founder.remaining': '{count} Founder seats remaining',
  'plans.founder.remaining_last': 'Last {count} Founder seats',
  'plans.founder.remaining_limited': 'Limited: {count} seats left',
  'plans.founder.remaining_very_low': 'Only {count} Founder seats left',
  'plans.founder.soldout': 'Founder sold out',
  'plans.compare.institucional.title': 'מוסדי',
  'plans.compare.yourPlan': 'התוכנית שלך',
  'plans.badges.foundation': 'Founder',
  'plans.modal.free.line1': '30,000 תווים לחודש לכל חשבון.',
  'plans.modal.free.line2': 'עד 2 אנשי קשר לכל משתמש.',
  'plans.modal.free.line3': 'עד 2 שיחות פעילות לכל חשבון.',
  'plans.modal.free.line4': 'ללא קבצים מצורפים או אחסון.',
  'plans.modal.free.line5': 'ללא ייצוא נתונים.',
  'plans.modal.free.line6': 'היסטוריית הודעות עד 30 יום.',
  'plans.modal.free.line7': 'מכשיר אחד בלבד לכל משתמש.',
  'plans.modal.premium.line1': '300,000 תווים לחודש לכל חשבון.',
  'plans.modal.premium.line2': 'עד 100 אנשי קשר לכל משתמש.',
  'plans.modal.premium.line3': 'שיחות וצ\'אטים ללא הגבלה (tenant).',
  'plans.modal.premium.line4': 'עד 50 MB אחסון (tenant).',
  'plans.modal.premium.line5': 'עד 3 מכשירים לכל משתמש.',
  'plans.modal.premium.line6': 'הזמנות ללא הגבלה (tenant).',
  'plans.modal.premium.line7': 'כולל ייצוא, תרגום אוטומטי וקבצים לפי מגבלות התוכנית.',
  'plans.modal.premium_block_heading': 'מגבלות שימוש במנוע (פרימיום)',
  'plans.modal.foundation.ribbon': 'Founder Access',
  'plans.modal.foundation.program_title': 'תוכנית Founder',
  'plans.modal.foundation.categories_title': 'קטגוריות Founder ({slots} מקומות)',
  'plans.modal.foundation.cat_legendary_title': 'LEGENDARY Founder',
  'plans.modal.foundation.cat_legendary_range': 'מיקום 1–25',
  'plans.modal.foundation.cat_legendary_desc': 'הראשונים שתמכו בפרויקט. עדיפות היסטורית מקסימלית.',
  'plans.modal.foundation.cat_early_title': 'EARLY Founder',
  'plans.modal.foundation.cat_early_range': 'מיקום 26–75',
  'plans.modal.foundation.cat_early_desc': 'תמיכה מוקדמת עם הכרה מיוחדת.',
  'plans.modal.foundation.cat_std_title': 'Founder',
  'plans.modal.foundation.cat_std_range': 'מיקום 76–150',
  'plans.modal.foundation.cat_std_desc': 'מקום Founder בתוך 150 המקומות.',
  'plans.modal.foundation.advantages_title': 'יתרונות Founder',
  'plans.modal.foundation.adv1': 'גישה לבריכת Founder המוגבלת ({slots} מקומות ממוספרות).',
  'plans.modal.foundation.adv2': 'הכרה כמשתמש מייסד של ArChat.',
  'plans.modal.foundation.adv3': 'תג Founder ונוכחות בחוויית המוצר.',
  'plans.modal.foundation.adv4': 'עדיפות היסטורית ומעמד לפי המיקום שלך (1–150).',
  'plans.modal.foundation.adv5': 'הטבה מתמשכת לגישת Founder כל עוד המדיניות הנוכחית נשמרת.',
  'plans.modal.pro.tagline': 'פרימיום סטנדרטי — ללא רכיב Founder',
  'plans.payments_disabled.title': 'מנויים',
  'plans.payments_disabled.message': 'מנויים מופעלים בהדרגה. ניתן לצפות בתוכניות הזמינות וביתרונותיהן.',
  'plans.payments_disabled.confirm': 'אישור',
};